module.exports = __webpack_public_path__ + "static/workflow-19a4916c96eb0f1eac7d26dff78694cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-invision/workflow.png
// module id = 2664
// module chunks = 260617349216052